import * as React from "react"
import * as CheckboxPrimitive from "@radix-ui/react-checkbox"
import { Check } from "lucide-react"

import { cn } from "../../lib/utils"

const Checkbox = React.forwardRef<
  React.ElementRef<typeof CheckboxPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof CheckboxPrimitive.Root>
>(({ className, ...props }, ref) => (
  <CheckboxPrimitive.Root
    ref={ref}
    className={cn(
      // border-solid explícito: el WebKit de iOS aplica border-style:none al
      // <button> de Radix (su UA stylesheet gana al preflight de Tailwind, que
      // solo lo pone vía `*`), así que `border` daba width sin estilo y la
      // casilla no se dibujaba (invisible en iOS). En Chrome ya era solid.
      // El root de Radix es un <button>. En iOS Safari tanto el estilo nativo
      // como los layouts flex pueden alterar su caja si solo se define h/w.
      // Declaramos cada invariante de tamaño para que un checkbox conserve una
      // caja cuadrada de 20 px con independencia del contexto que lo contiene.
      "peer inline-flex h-5 w-5 min-h-5 min-w-5 max-h-5 max-w-5 aspect-square shrink-0 box-border appearance-none items-center justify-center rounded-sm border border-solid border-primary p-0 ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:bg-primary data-[state=checked]:text-primary-foreground",
      className
    )}
    {...props}
  >
    <CheckboxPrimitive.Indicator
      className={cn("flex h-full w-full items-center justify-center text-current")}
    >
      <Check className="h-4 w-4" />
    </CheckboxPrimitive.Indicator>
  </CheckboxPrimitive.Root>
))
Checkbox.displayName = CheckboxPrimitive.Root.displayName

export { Checkbox }
